/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const form2Slice = createSlice({
  name: 'form2',
  initialState: {
    typeVehicle: '',
    typeVehiclePrefix: '',
    brand: '',
    subbrand: '',
    model: '',
    version: '',
    // versionKeyKS is the main id to identify a vehicle in the DB (cvegs in the api)
    versionKeyGS: '',
    plans: {},
    wasValidatedBefore: false,
  },
  reducers: {
    setForm2TransactionData(state, { payload }) {
      state.typeVehicle = payload.typeVehicle;
      state.typeVehiclePrefix = payload.typeVehiclePrefix;
      state.brand = payload.brand;
      state.subbrand = payload.subbrand;
      state.model = payload.model;
      state.version = payload.version;
      state.versionKeyGS = payload.keyGS;
      state.plans = payload.planes;
      state.wasValidatedBefore = true;
    },
  },
});

export const form2Actions = form2Slice.actions;

export default form2Slice;
/* eslint-enable no-param-reassign */
